import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('BackgroundJobs.BackgroundJobs.deleteRunner'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: _vm.color,
        emit: 'delete'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": _vm.deleteItem
    }
  }), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('BackgroundJobs.BackgroundJobs.cancelConfirmTitleCsvImport'),
      "open": _vm.cancelPromptCsvImport,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.cancel'),
        color: _vm.color,
        emit: 'cancelRunner'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.cancelPromptCsvImport = false;
      },
      "cancelRunner": _vm.cancelRunner
    }
  }), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('BackgroundJobs.BackgroundJobs.cancelConfirmTitleBulkEdit'),
      "open": _vm.cancelPromptBulkEdit,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.cancel'),
        color: _vm.color,
        emit: 'cancelRunner'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.cancelPromptBulkEdit = false;
      },
      "cancelRunner": _vm.cancelRunner
    }
  }), _c(VRow, {
    class: _vm.containerClass,
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm.isEmptyList ? [_c('core-n20Card', [_c('core-empty-state', {
    attrs: {
      "icon": _vm.jobType === 'digitalTwinBulkDuplicate' ? 'fal fa-dice-d8' : 'fa-sensor-on',
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n              " + _vm._s(_vm.noJobs) + "\n            ")];
      },
      proxy: true
    }], null, false, 3618670341)
  })], 1)] : [_c(VDataTable, {
    staticClass: "row-pointer",
    attrs: {
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.tableHeaders,
      "footer-props": _vm.tableFooterProps,
      "single-select": false,
      "item-key": "id",
      "page": _vm.tableOptions.page,
      "data-cy": "bg_jobs_table"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      },
      "click:row": _vm.handleClickRunner
    },
    scopedSlots: _vm._u([{
      key: "item.title",
      fn: function ({
        item
      }) {
        return [_c('p', {
          staticClass: "title-cell ma-0 text-truncate",
          attrs: {
            "title": item.title
          }
        }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])];
      }
    }, {
      key: "item.tasks",
      fn: function ({
        item
      }) {
        return [_c('span', [_vm._v("\n              " + _vm._s(item.tasks.total) + "\n            ")])];
      }
    }, {
      key: "item.state",
      fn: function ({
        item
      }) {
        return [_c('span', {
          class: {
            'red--text': item.tasks.errors,
            'green--text': item.state === 'done'
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t(`BackgroundJobs.BackgroundJobs.status.${item.state.replace(' ', '')}`)) + "\n            ")])];
      }
    }, {
      key: "item.tasks.errors",
      fn: function ({
        item
      }) {
        return [_c('span', {
          class: {
            'red--text': item.tasks.errors && item.tasks.errors !== null
          }
        }, [_vm._v("\n              " + _vm._s(item.tasks.errors || '-') + "\n            ")])];
      }
    }, {
      key: "item.createdAt",
      fn: function ({
        item
      }) {
        return [_c('span', [_vm._v("\n              " + _vm._s(_vm.localizeDate(item.createdAt)) + "\n            ")])];
      }
    }, {
      key: "item.userCreated",
      fn: function ({
        item
      }) {
        return [_c('p', {
          staticClass: "username-cell ma-0 text-truncate",
          attrs: {
            "title": `${item.userCreated.firstName} ${item.userCreated.lastName} -  ${item.userCreated.email}`
          }
        }, [_vm._v("\n              " + _vm._s(item.userCreated.email) + "\n            ")])];
      }
    }, {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "d-flex justify-end align-right"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": "",
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.$emit('show-item-info', item);
            }
          }
        }, [_vm._v("fal fa-eye")]), _vm._v("\n               \n              "), [_vm.canDeleteItem && item.state !== 'in progress' ? _c(VIcon, {
          staticClass: "ml-2",
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.showDeletePrompt(item);
            }
          }
        }, [_vm._v("\n                  fal fa-trash-alt\n                ")]) : _vm._e(), _vm.canDeleteItem && item.state == 'in progress' ? _c(VIcon, {
          staticClass: "ml-2",
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.cancel'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.showCancelPrompt(item);
            }
          }
        }, [_vm._v("\n                  fal fa-times-circle\n                ")]) : _vm._e()]], 2)];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n            " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n          ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })]], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };